import { css } from "styled-components";
import { riotProductSkin } from "../riot-product";
export const projectLStyle = (chroma, paletteTokens) => css `
  ${riotProductSkin(chroma, paletteTokens)}

  &.icon-link,
  &.icon-checkmark,
  &.icon-linkUrl,
  &.icon-accordionPlus,
  &.icon-accordionMinus,
  &.icon-arrowRight,
  &.icon-arrowLeft,
  &.icon-dropdown,
  &.icon-search,
  &.icon-close,
  &.icon-platformWindows,
  &.icon-platformMac,
  &.icon-platformIos,
  &.icon-platformAndroid,
  &.icon-platformPC,
  &.icon-platformPSN,
  &.icon-platformXbox,
  &.icon-playstation,
  &.icon-xbox,
  &.icon-marqueeArrowRight {
    background-color: ${paletteTokens.accents1};
  }

  /*
    Note: Carousel lef/right icons have 2 colors and we can't use masks for them.
    Alternatively, we could use the arrow icons and define a css-based circle around them.
   */
  &.icon-carouselRight,
  &.icon-carouselLeft {
    width: 53px;
    height: 20px;
    background-color: ${paletteTokens.accents1};
  }

  &.icon-action-play-video {
    height: 110px;
    width: 110px;
    display: inline-block;
    background-image: url(${chroma.icons.player});
    background-size: 100% 100%;
  }
`;
//# sourceMappingURL=index.js.map